import React, { ReactNode } from 'react';
import {
    Container,
    LeftSidemenu as StyledLeftSidemenu,
    MainContentArea,
    Header as StyledHeader,
    ContentContainer,
} from './ToolsPageLayout.styles';
import { Icon, IconButton, Tooltip, Typography, useTheme } from '../../base';
import LeftSidemenuComponent from './LeftSidemenu';
import RightSidemenuComponent from './RightSidemenu';
import fullTextLogo from '/assets/fullTextLogo.svg';
import { useTranslation } from 'react-i18next';
import SlidingDrawer from '../SlidingDrawer';

interface Props {
    children: ReactNode;
}

const ToolsPageLayout = ({ children }: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const placement = theme.direction === 'rtl' ? 'left' : 'right';

    const renderTopHeader = () => {
        return (
            <StyledHeader>
                <img
                    src={fullTextLogo}
                    alt="Pargoda Logo"
                    style={{
                        height: '20px',
                        display: 'block',
                    }}
                />
                <Tooltip title={t('tools.moreToolsComingSoon')}>
                    <span>
                        <IconButton disabled aria-label="more tools">
                            <Icon name="AppsIcon" />
                        </IconButton>
                    </span>
                </Tooltip>
            </StyledHeader>
        );
    };

    return (
        <Container>
            <StyledLeftSidemenu>
                <LeftSidemenuComponent />
            </StyledLeftSidemenu>
            <MainContentArea>
                {renderTopHeader()}
                <ContentContainer>{children}</ContentContainer>
            </MainContentArea>
            <SlidingDrawer
                placement={placement}
                positionOffset="50%"
                tabContent={
                    <Typography variant="body2" color="text.secondary">
                        {t('tools.companyInformation')}
                    </Typography>
                }
                tabIcon={'HandymanOutlinedIcon'}
            >
                <div
                    style={{
                        width: '300px',
                        height: '100%',
                        overflowY: 'auto',
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    <RightSidemenuComponent />
                </div>
            </SlidingDrawer>
        </Container>
    );
};

export default ToolsPageLayout;
